module.exports = __webpack_public_path__ + "static/img/other.ad5eda9c.png";